import type { JSX } from "react";
import { useAtom } from "jotai";

import { CodFluxoEtapaStatus } from "@repo/graphql-types/graphql";

import { ProceduresTermsSubStep } from "@/components/flows/steps/council/components/procedures-terms-sub-step";
import { ALL_PROFESSIONS, PROFESSIONS_WITH_CERTIFICATE } from "@/components/flows/steps/council/utils/professions";
import { ProgressRoundedLayout } from "@/components/ui/layout/progress-rounded-layout";
import { useSubStepNavigation } from "@/hooks/use-sub-step-navigation";
import { councilStepAtom } from "@/lib/atoms/council-step-atom";
import { useFlowStepContext } from "@/lib/context/flow-step-context";
import { getIP } from "@/lib/ip-getter";
import { flattenToJsonString } from "@/lib/utils/flatten-to-json-string";

export const TermsPage = (): JSX.Element => {
  const { step, nextStep, isLoading, progress } = useFlowStepContext();
  const [councilState, setCouncilState] = useAtom(councilStepAtom);
  const { goToSubStep } = useSubStepNavigation();

  const handleSubmit = async () => {
    const { profession, professionName, councilNumber, councilAcronym, uf, procedures } = councilState;
    const resolvedProfessionName =
      professionName ?? ALL_PROFESSIONS.find((p) => p.value === profession)?.label ?? null;
    const resolvedCouncilAcronym =
      councilAcronym ?? ALL_PROFESSIONS.find((p) => p.value === profession)?.council ?? null;
    if (procedures === "sim" && profession && PROFESSIONS_WITH_CERTIFICATE.has(profession)) {
      goToSubStep("aesthetic-procedures");
      return;
    }
    const ipAddress = await getIP();
    void nextStep({
      ...step,
      resposta: flattenToJsonString({ profession, professionName: resolvedProfessionName, councilNumber, councilAcronym: resolvedCouncilAcronym, uf, procedures, ipAddress }),
      status: CodFluxoEtapaStatus.Concluido,
    });
  };

  return (
    <ProgressRoundedLayout progress={progress} onBack={() => { goToSubStep("council"); }}>
      <ProceduresTermsSubStep
        defaultValue={councilState.procedures}
        onChange={(value) => { setCouncilState((s) => ({ ...s, procedures: value })); }}
        onSubmit={handleSubmit}
        isLoading={isLoading}
        isValid={Boolean(councilState.procedures)}
        buttonText={step.configuracoes?.textoBotao ?? "Continuar"}
      />
    </ProgressRoundedLayout>
  );
};
